import React, { useEffect, useState } from 'react';
import InputForm from '../../../InputT';
//import "../../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box } from '@mui/material';
import { Button, Input, Spin, Table } from 'antd';
import { SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import SearchInput from '../../../SearchInput';
import { ColumnsType } from 'antd/es/table';
import axios from 'axios';
import { Crypter } from '../../../../Functions/Security/Crypter';
import DataType from '../../../../Types/DataTablePiclist';
import Datas from '../../../../Data/Data.json'
import File from '../../../File';
import DataTypeTable from '../../../../Types/DataTypeTable';
import SearchModal from '../../../SearchModal';
import Billetage from '../../../Billetage';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';

const columns: ColumnsType<DataTypeTable> = [
  {
    title: 'N° Identification',
    dataIndex: 'NUMIDENTI',
  },
  {
    title: 'Type Garantie',
    dataIndex: 'typgar',
  },
  {
    title: 'Localisation',
    dataIndex: 'LOCAL',
  },
  {
    title: 'Valeur Garantie',
    dataIndex: 'VALGARANTI',
  },
  {
    title: 'Désignation',
    dataIndex: 'DESIGNATION',
  },
  {
    title: 'Date Début',
    dataIndex: 'DATDEB',
  },
  {
    title: 'Date Fin',
    dataIndex: 'DATFIN',
  },
  {
    title: 'Commentaire',
    dataIndex: 'TEXTCOMMEN',
  }
];

let searchUser: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }


let searchTypAdr: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }



//Initialisation des parametres de recherche
let searchTitre: Params = { CodeAgence: '', Table: "TITRES", Colonne1: "CDTITR", Colonne2: "LIBELL1", Colagence: '101', Choix: 22 }
let searchSituationFamiliale: Params = { CodeAgence: "SITFAM", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
let searchProspect: Params = { CodeAgence: '', Table: "DEMARC", Colonne1: "CODDMR", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchClassRisque: Params = { CodeAgence: '', Table: "CLARIS", Colonne1: "CLARIS", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchPays: Params = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchActivite: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchUniteInstitutionnel: Params = { CodeAgence: '', Table: "TABNUI", Colonne1: "CODNUI", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchRegimeMatrimonial: Params = { CodeAgence: "REGMAT", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
//
let searchNiveauInstruction: Params = { CodeAgence: '', Table: "INSTRU", Colonne1: "CODINS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchEthnie: Params = { CodeAgence: '', Table: "ETHNIE", Colonne1: "CODETH", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchCateGo: Params = { CodeAgence: '', Table: "CATEGO", Colonne1: "CATEGO", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchZoneGeo: Params = { CodeAgence: '', Table: "RESIDE", Colonne1: "CDRESI", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchCpt: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "plc2", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGroup: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchService: Params = { CodeAgence: '', Table: "SERVICE", Colonne1: "CODSERV", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchCompte: Params = { CodeAgence: '', Table: "CCOMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }
let searchStatus: Params = { CodeAgence: '', Table: "Status", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchGroupUtilis: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGarantie: Params = { CodeAgence: '', Table: "GARANTIE", Colonne1: "", Colonne2: "", Colagence: '101', Choix: 3 }
let searchTypeGrantie: Params = { CodeAgence: '', Table: "TYPEGARANTIE", Colonne1: "codgar", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchGarantieForm: Params = { CodeAgence: '', Table: "GARANTIE", Colonne1: "codgar", Colonne2: "DESIGNATION", Colagence: '101', Choix: 22 }



function Tab1(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))


  // useEffect(()=>{
  //   getTotal()
  // })

  // USER TOKEN
  const authHeader = useAuthHeader()

  // function getTotal() {
  //   let val = formatNumber(
  //     parseInt((props.form.getFieldValue("NOMB01")? props.form.getFieldValue("NOMB01") : 0))*10000+
  //     parseInt((props.form.getFieldValue("NOMB02")? props.form.getFieldValue("NOMB02") : 0))*5000+
  //     parseInt((props.form.getFieldValue("NOMB03")? props.form.getFieldValue("NOMB03") : 0))*2000+
  //     parseInt((props.form.getFieldValue("NOMB04")? props.form.getFieldValue("NOMB04") : 0))*1000+
  //     parseInt((props.form.getFieldValue("NOMB05")? props.form.getFieldValue("NOMB05") : 0))*500+
  //     parseInt((props.form.getFieldValue("NOMB06")? props.form.getFieldValue("NOMB06") : 0))*500+
  //     parseInt((props.form.getFieldValue("NOMB07")? props.form.getFieldValue("NOMB07") : 0))*100+
  //     parseInt((props.form.getFieldValue("NOMB08")? props.form.getFieldValue("NOMB08") : 0))*50+
  //     parseInt((props.form.getFieldValue("NOMB09")? props.form.getFieldValue("NOMB09") : 0))*25+
  //     parseInt((props.form.getFieldValue("NOMB10")? props.form.getFieldValue("NOMB10") : 0))*10+
  //     parseInt((props.form.getFieldValue("NOMB11")? props.form.getFieldValue("NOMB11") : 0))*5+
  //     parseInt((props.form.getFieldValue("NOMB12")? props.form.getFieldValue("NOMB12") : 0))*2+
  //     parseInt((props.form.getFieldValue("NOMB13")? props.form.getFieldValue("NOMB13") : 0))*1)
      
  //   props.form.setFieldValue('EETSRL', val)

    
  //   props.form.setFieldValue('difference', ReformatNumber(val) - props.form.getFieldValue('EEPEAE'))
  // }
  
  return (
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border border-left' width={"85%"} position={"absolute"}>
          <Box fontStyle="inherit" >
            <legend>Information sur la caisse</legend>
            <Box display={"flex"} fontStyle="inherit" marginTop={-2}>
              <InputForm width={5} disabled label='N°' icon={<SwipeUp color='disabled' fontSize='small' />} name='NODECE' type='text' error='mobile' />
              <InputForm width={5} disabled label='Nom' icon={<SwipeUp color='disabled' fontSize='small' />} name='LECEON' type='text' error='mobile' />
              <InputForm width={6} disabled label='Statut' icon={<SwipeUp color='disabled' fontSize='small' />} name='CDETAT' type='text' error='mobile' />
              <InputForm width={9} disabled label='N° de compte' icon={<SwipeUp color='disabled' fontSize='small' />} name='NUMCPT' type='text' error='mobile' />
            </Box>
          </Box>
          <Billetage form={props.form}  />
          <legend>Autre détails</legend>
          <Box display={"flex"} fontStyle="inherit" >
            <Box fontStyle="inherit" display={'flex'} marginTop={-2} className='bordure1'>
              <Box fontStyle={"inherit"} >
                <InputForm width={11} disabled label='Encaisse début jrné' icon={<SwipeUp color='disabled' fontSize='small' />} name='EEDTJE' type='number' error='mobile' />
                <InputForm width={11} disabled label='Versement' icon={<SwipeUp color='disabled' fontSize='small' />} name='CLOSVT' type='number' error='mobile' />
                <InputForm width={11} disabled label='Entrée fond banque' icon={<SwipeUp color='disabled' fontSize='small' />} name='MTENFDBANQ' type='number' error='mobile' />
                <InputForm width={11} disabled label='Reception coffre' icon={<SwipeUp color='disabled' fontSize='small' />} name='MTRECOFF' type='number' error='mobile' />
                <InputForm width={11} disabled label='Recept° autre caisse' icon={<SwipeUp color='disabled' fontSize='small' />} name='MTDIVRE' type='number' error='mobile' />
                <InputForm notRequired width={11} disabled label='Total encaissement' icon={<SwipeUp color='disabled' fontSize='small' />} name='totalEncais' type='number' error='mobile' />
              </Box>
              <Box fontStyle="inherit" >
                <InputForm type={'hidden'} />
                <InputForm width={11} disabled label='Paiements' icon={<SwipeUp color='disabled' fontSize='small' />} name='CLOSPT' type='number' error='mobile' />
                <InputForm width={11} disabled label='Sortie fond banque' icon={<SwipeUp color='disabled' fontSize='small' />} name='MTSTFDBANQ' type='number' error='mobile' />
                <InputForm width={11} disabled label='Emission coffre' icon={<SwipeUp color='disabled' fontSize='small' />} name='MTEMCOFF' type='number' error='mobile' />
                <InputForm width={11} disabled label='Emission autre caisse' icon={<SwipeUp color='disabled' fontSize='small' />} name='MTDIVEM' type='number' error='mobile' />
                <InputForm notRequired width={11} disabled label='Total decaissement' icon={<SwipeUp color='disabled' fontSize='small' />} name='totalDec' type='number' error='mobile' />
              </Box><hr />
            </Box><hr />
            <Box fontStyle={"inherit"}>
              <Box display={"flex"} fontStyle={"inherit"} marginTop={-3} >

                <Box fontStyle="inherit" className='bordure1' >
                  <InputForm notRequired width={11} disabled label='Encaissement physiq' icon={<SwipeUp color='disabled' fontSize='small' />} name='EETSRL' type='text' error='mobile' />
                  <InputForm width={11} disabled label='Encaissement info' icon={<SwipeUp color='disabled' fontSize='small' />} name='EEPEAE' type='number' error='mobile' />
                  <InputForm notRequired width={11} disabled label='Ecart de caisse' icon={<SwipeUp color='disabled' fontSize='small' />} name='difference' type='number' error='mobile' />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

      </div>
    </div>
  )
}

export default Tab1;  
